import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import questionConfigs from 'modules/surveys/store/collections/questionConfigs'
import type QuestionConfig from 'modules/surveys/store/models/QuestionConfig'

export interface IQuestionCategory {
  id: string
  name: string
  surveys_question_group_config_id: string
}

class QuestionCategory extends Model<IQuestionCategory> {
  constructor(attr: IQuestionCategory) {
    super(attr)
    makeObservable(this, {
      questionConfigs: computed,
      archivedQuestionConfigs: computed,
    })
  }

  static urlRoot() {
    return '/surveys/question_categories'
  }

  get indexes() {
    return ['surveys_form_id']
  }

  get name(): string {
    return this.attributes.name
  }

  get questionConfigs(): QuestionConfig[] {
    return questionConfigs.filter({
      surveys_question_category_id: this.attributes.id,
      archived: false,
    })
  }

  get archivedQuestionConfigs(): QuestionConfig[] {
    return questionConfigs.filter({
      surveys_question_category_id: this.attributes.id,
      archived: true,
    })
  }
}

export default QuestionCategory
